import { render, staticRenderFns } from "./SuggestionItem.vue?vue&type=template&id=9348bcf2&scoped=true"
import script from "./SuggestionItem.vue?vue&type=script&lang=js"
export * from "./SuggestionItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9348bcf2",
  null
  
)

export default component.exports